import * as yup from "yup";
import { validateDate, validateTimeNotInFuture } from "../datetime";

export const customerInteractionSchema = (config) => yup.object().shape({
  interactionTime: yup
    .string()
    .required("Time is required")
    .test("not-in-future", "Time cannot be in the future", function (time) {
      const { interactionDate } = this.parent;
      return validateTimeNotInFuture(time, interactionDate);
    }),

  searchedCustomer: yup.string().notRequired(),

  customer: yup.object().required("Selected customer is required"),

  isCustomerVulnerable: yup.boolean(),
  isCustomerOk: yup.boolean(),
  customerUnknown: yup.boolean(),

  reason: yup.number().when("isCustomerVulnerable", {
    is: true,
    then: (s) => s.required("Reason for interaction is required"),
    otherwise: (s) => s.notRequired(),
  }),

  outcome: yup.number().when("isCustomerVulnerable", {
    is: true,
    then: (s) => s.required("Outcome is required"),
    otherwise: (s) => s.notRequired(),
  }),

  otherOutcome: yup.string().when("outcome", {
    is: 4,
    then: (s) => s.required("Outcome description is required"),
  }),

  actionTaken: yup.number().when("isCustomerVulnerable", {
    is: true,
    then: (s) => s.required("Action is required"),
  }),

  /*
  ========================
  VULNERABLE FEATURE FLAG
  ========================
  */

  isVulnerable: config.hasSetVulnerable ?
    yup
      .boolean()
      .required(
        "Please specify whether or not to flag the customer as vulnerable"
      )
  : yup.boolean().nullable().notRequired(),

  providedLeaflet: yup.boolean().when("isVulnerable", {
    is: (isVulnerable) => config.hasSetVulnerable && isVulnerable,
    then: (s) =>
      s.required("Please specify whether or not leaflet was provided"),
    otherwise: (s) => s.nullable().notRequired(),
  }),

  reasonNotProvidedLeaflet: yup.string().when(
    ["isVulnerable", "providedLeaflet"],
    {
      is: (vul, leaflet) => config.hasSetVulnerable && vul && !leaflet,
      then: (s) =>
        s.required("Please provide reason why leaflet was not provided"),
      otherwise: (s) => s.notRequired(),
    }
  ),

  seekHelp: yup.boolean().when("isVulnerable", {
    is: (isVulnerable) => config.hasSetVulnerable && isVulnerable,
    then: (s) =>
      s.required("Please specify whether help guidance was explained"),
    otherwise: (s) => s.nullable().notRequired(),
  }),

  reasonNotSeekHelp: yup.string().when(
    ["isVulnerable", "seekHelp"],
    {
      is: (vul, help) => config.hasSetVulnerable && vul && !help,
      then: (s) =>
        s.required("Please provide reason why help guidance was not explained"),
      otherwise: (s) => s.notRequired(),
    }
  ),

  discussedSelfExclusion: yup.boolean().when("isVulnerable", {
    is: (isVulnerable) => config.hasSetVulnerable && isVulnerable,
    then: (s) =>
      s.required("Please specify whether self-exclusion was discussed"),
    otherwise: (s) => s.notRequired(),
  }),

  reasonNotDiscussedSelfExclusion: yup.string().when(
    ["isVulnerable", "discussedSelfExclusion"],
    {
      is: (vul, discussed) => config.hasSetVulnerable && vul && !discussed,
      then: (s) =>
        s.required("Please provide reason why self-exclusion wasn't discussed"),
      otherwise: (s) => s.notRequired(),
    }
  ),

  selfExclude: yup.boolean().when(
    ["isVulnerable", "discussedSelfExclusion"],
    {
      is: (vul, discussed) => config.hasSetVulnerable && vul && discussed,
      then: (s) =>
        s.required("Please specify whether customer wishes to self-exclude"),
      otherwise: (s) => s.nullable().notRequired(),
    }
  ),

  reasonNotSelfExclude: yup.string().when(
    ["isVulnerable", "discussedSelfExclusion", "selfExclude"],
    {
      is: (vul, discussed, selfEx) => config.hasSetVulnerable && vul && discussed && !selfEx,
      then: (s) =>
        s.required("Please provide reason why customer did not self-exclude"),
      otherwise: (s) => s.notRequired(),
    }
  ),

  /*
  ========================
  TEMP BREAK FEATURE FLAG
  ========================
  */

  temporaryBreak: config.hasSetTemporaryBreak
  ? yup
      .boolean()
      .required("Please specify whether a temporary break is required")
  : yup.boolean().nullable().notRequired(),

  endDateOfBreak: yup.string().when("temporaryBreak", {
    is: (temporaryBreak) => config.hasSetTemporaryBreak && temporaryBreak,
    then: (s) =>
      s
        .required("Return date is required")
        .test("is-valid-date", "Return date is not valid", validateDate),
    otherwise: (s) => s.nullable().notRequired(),
  }),

  comments: yup.string().notRequired(),
});